// Display formatters for the admin console (English UI). humanize() turns raw DB enum values into
// readable labels (sentence case + domain acronyms) so no snake_case surfaces.
const ACRONYMS: Record<string, string> = {
  dpia: "DPIA", avg: "AVG", gdpr: "GDPR", fg: "FG", dpo: "DPO", scc: "SCC", bcr: "BCR", crm: "CRM",
  dsar: "DSAR", ai: "AI", eer: "EER", eu: "EU", us: "US", iso: "ISO", nen: "NEN", kpi: "KPI",
  wp: "WP", pbd: "PbD", ropa: "RoPA",
};

export function humanize(value: unknown): string {
  const s = String(value ?? "").trim();
  if (!s) return "—";
  return s.split("_").map((w, i) => {
    const lw = w.toLowerCase();
    if (ACRONYMS[lw]) return ACRONYMS[lw];
    return i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : lw;
  }).join(" ");
}
